import { CircleCircle, CircleConsentTypes } from '@calm/evexia-web-sdk';
import { useTracking } from '@rhg/libs/analytics';
import createCircleApi from '@rhg/libs/api/create-circle-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { useMutation } from '@rhg/libs/react-query';

export function useCopyCircle() {
    const { getAccessTokenSilently } = useAuth();
    const { setUserProfile, flush } = useTracking();
    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async ({
            healthcarePortabilityVersion,
            consentSig,
            circle,
        }: {
            healthcarePortabilityVersion: number;
            consentSig: string;
            circle: CircleCircle;
        }) => {
            if (!healthcarePortabilityVersion) {
                throw new Error('No healthcare portability version');
            }
            const api = createCircleApi(getAccessTokenSilently);

            const recipientId = circle.sponsor?.recipientId || 0;
            const circleCopyRequest = {
                consentType: CircleConsentTypes.HealthcarePortability,
                consentVer: healthcarePortabilityVersion,
                consentSig,
            };
            const response = await api.v1CopyCircle({
                recipientId,
                circleCopyRequest,
                circleAuthorizationToken: circle.authorizationJWT,
            });

            await setUserProfile({ PartnerID: '' });
            await flush();
            return response.data;
        },
    });
    return {
        copyCircle: mutate,
        copyCircleAsync: mutateAsync,
        ...otherProps,
    };
}
